import { configureStore, Reducer } from '@reduxjs/toolkit';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer } from './combineReducer/combineReducer';

const persistConfig = {
	key: 'bulk-sms',
	storage,
};

const persistedRootReducer = persistReducer(persistConfig, rootReducer as Reducer);

export const store = configureStore({
	reducer: persistedRootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}).concat(),
	devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
// persistor.purge();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
